import React from 'react';
import pt from 'prop-types';
import isEqual from 'lodash/isEqual';

import { EasyblocksBackendContext } from 'components/storefront/editor/backendContext';
import SwellLookup from 'components/storefront/editor/widgets/lookup';

export default class SwellMenu extends React.PureComponent {
  static contextType = EasyblocksBackendContext;

  static propTypes = {
    value: pt.string,
    field: pt.object,
    onChange: pt.func,
  };

  state = {
    menus: [],
    record: null,
    loaded: false,
  };

  lastSearchValue = '';

  componentDidMount() {
    const menus = this.getMenus();
    const record = this.getRecord(menus);

    this.setState({ menus, record, loaded: true });
  }

  componentDidUpdate(prevProps, prevState) {
    const menus = this.getMenus();

    if (!isEqual(prevState.menus, menus)) {
      this.setState({ menus, record: this.getRecord(menus) }, () => {
        this.searchMenusAndFulfillResults(this.lastSearchValue);
      });
    }
  }

  getMenus() {
    const { storefrontConfigs } = this.context;

    return storefrontConfigs.menus?.values?.menus || [];
  }

  getRecord(menus = this.getMenus(), value = this.props.value) {
    return menus.find((menu) => menu.id === value) || null;
  }

  onFieldChange = (value) => {
    const { onChange } = this.props;
    const { menus } = this.state;
    const record = this.getRecord(menus, value);

    onChange(record?.id);

    this.setState({ record });
  };

  onLookupValue = (value) => {
    const { menus } = this.state;

    return this.getRecord(menus, value);
  };

  getFilteredMenuResults(value) {
    const { menus } = this.state;

    if (!value) {
      return menus;
    }

    return menus.filter((menu) =>
      menu.name.toLowerCase().includes(value.toLowerCase()),
    );
  }

  searchMenusAndFulfillResults(value) {
    const { queryLookupResults } = this.context;
    const filteredResults = this.getFilteredMenuResults(value);

    return queryLookupResults(filteredResults);
  }

  onQuery = (query) => {
    this.lastSearchValue = query;

    return this.searchMenusAndFulfillResults(query);
  };

  render() {
    const { record, loaded } = this.state;

    if (!loaded) {
      return null;
    }

    return (
      <SwellLookup
        {...this.props}
        collection="menus"
        record={record}
        value={record?.id || null}
        onQuery={this.onQuery}
        onChange={this.onFieldChange}
        onLookupValue={this.onLookupValue}
      />
    );
  }
}
